<rid-demo-page [title]="'Klankbord'" previousRoute="/mechanics">
  <div class="flex flex-col gap-2">
    <h2>Freeform</h2>
    <rid-button
      class="w-full"
      content="Monosyllabisch Klankbord (volledig)"
      variant="PRIMARY"
      routerLink="monosyllabic-freeform"
      [queryParams]="{ mode: 'BOTH' }"
    />
    <rid-button
      class="w-full"
      content="Monosyllabisch Klankbord (groepen)"
      variant="PRIMARY"
      routerLink="monosyllabic-freeform"
      [queryParams]="{ mode: 'GROUP' }"
    />
    <rid-button
      class="w-full"
      content="Monosyllabisch Klankbord (klanken)"
      variant="PRIMARY"
      routerLink="monosyllabic-freeform"
      [queryParams]="{ mode: 'KLANK' }"
    />
  </div>
  <div class="flex flex-col gap-2">
    <h2>Oefening</h2>
    <rid-button
      class="w-full"
      content="Monosyllabisch Klankbord (volledig)"
      variant="PRIMARY"
      routerLink="monosyllabic"
      [queryParams]="{ mode: 'BOTH' }"
    />
    <rid-button
      class="w-full"
      content="Monosyllabisch Klankbord (groepen)"
      variant="PRIMARY"
      routerLink="monosyllabic"
      [queryParams]="{ mode: 'GROUP' }"
    />
    <rid-button
      class="w-full"
      content="Monosyllabisch Klankbord (klanken)"
      variant="PRIMARY"
      routerLink="monosyllabic"
      [queryParams]="{ mode: 'KLANK' }"
    />
  </div>
</rid-demo-page>
